// extracted by mini-css-extract-plugin
module.exports = {"header":"TradeForm_header__2j9eM","load":"TradeForm_load__1DIfQ"};